<script>
import Gltf from '../snippets/Gltf'

import { colors } from '@/config'

import getOptionsString from '@/util/getOptionsString'

export default {

  components: {
    Gltf
  },

  data () {
    return {
      isFiring: false
    }
  },

  computed: {

    // https://github.com/IdeaSpaceVR/aframe-particle-system-component
    firingParticlesOptions () {
      return getOptionsString({
        enabled: this.isFiring,
        preset: 'default',
        maxAge: 0.1,
        positionSpread: [0, 0, 0],
        velocityValue: [0, 2, 0],
        particleCount: 5,
        type: 1,
        rotationAxis: 'y',
        // rotationAngle: 3.14,
        rotationAngleSpread: 0,
        size: 0.5,
        // texture: ''
        color: [
          colors.red,
          colors.yellow
        ].join(',')
      })
    }

  },

  methods: {

    startFiringParticles () {
      // this.$refs.firingParticles.components['particle-system'].startParticles()
      this.isFiring = true
    },

    stopFiringParticles () {
      // this.$refs.firingParticles.components['particle-system'].stopParticles()
      this.isFiring = false
    }

  }

}
</script>

<template>
  <a-entity
    bb
    geometry="primitive: box; width: 1; height: 2; depth: 1;"
    material="visible: false"
  >
    <gltf
      src="/models/russian-soldier/scene.gltf"
      :scale="0.0006"
      position="0 -0.9 0"
    />

    <a-entity
      ref="firingParticles"
      position="0 0 0"
      :particle-system="firingParticlesOptions"
    />

  </a-entity>
</template>
